import { GridService } from '../shared/grid/grid.service';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Agent, AgentRecordHistory } from '../models/agent.model';
import { GridModel } from '../shared/grid/grid.model';
import { ColumnDetails } from '../models/columnDetails.model';
import { AgentLookup } from '../models/agentLookup.model';

@Injectable({
    providedIn: 'root'
})
export class AgentService extends GridService<Agent> {

    constructor(http: HttpClient) {
        super('Agent', http);
    }

    override getAll(filterBy: string = ''): Observable<AgentLookup[]> {
        return this.http.get<AgentLookup[]>(this.getApiUrl(`${this.controllerName}/GetAll?filterBy=${filterBy}`));
    }

    getHistory(params: HttpParams): Observable<GridModel<AgentRecordHistory>> {
        return this.http.get<GridModel<AgentRecordHistory>>(this.getApiUrl(`${this.controllerName}/GetHistory`), {
            params: params
        });
    }

    getHistoryFieldConfiguration(): Observable<{ [property: string]: ColumnDetails }> {
        return this.http.get<{ [property: string]: ColumnDetails }>(
            this.getApiUrl(`${this.controllerName}/GetHistoryFieldConfiguration`)
        );
    }

    getDeletedList(filter: string, orderBy: string, sort: string, page: number, pageSize: number): Observable<GridModel<Agent>> {
        return this.http.get<GridModel<Agent>>(this.getApiUrl(`${this.controllerName}/GetDeletedList`), {
            params: this.createParamsWithFilterBy(filter, orderBy, sort, page, pageSize, '{}'),
        });
    }

    restore(id: string): Observable<void> {
        return this.http.post<void>(this.getApiUrl(`${this.controllerName}/Restore/${id}`), {});
    }
}
